var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/navigation-items.j2"] = require( "macros/navigation-items.j2" );
dependencies["social/facebook.j2"] = require( "social/facebook.j2" );
dependencies["social/instagram.j2"] = require( "social/instagram.j2" );
dependencies["social/twitter.j2"] = require( "social/twitter.j2" );
dependencies["social/spotify.j2"] = require( "social/spotify.j2" );
dependencies["social/pinterest.j2"] = require( "social/pinterest.j2" );
dependencies["social/youtube.j2"] = require( "social/youtube.j2" );
dependencies["social/google-plus.j2"] = require( "social/google-plus.j2" );
dependencies["social/tumblr.j2"] = require( "social/tumblr.j2" );
dependencies["social/snapchat.j2"] = require( "social/snapchat.j2" );
dependencies["social/songdrop.j2"] = require( "social/songdrop.j2" );
dependencies["social/vimeo.j2"] = require( "social/vimeo.j2" );
dependencies["social/flickr.j2"] = require( "social/flickr.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/footer/social.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/navigation-items.j2", false, "core/templates/footer/social.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("renderNavItem")) {
var t_4 = t_1.renderNavItem;
} else {
cb(new Error("cannot import 'renderNavItem'")); return;
}
context.setVariable("renderNavItem", t_4);
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"footerNavigation")) {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"footerNavigation")),"social")) {
var t_5;
t_5 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"footerNavigation")),"social");
frame.set("socialNavItem", t_5, true);
if(frame.topLevel) {
context.setVariable("socialNavItem", t_5);
}
if(frame.topLevel) {
context.addExport("socialNavItem", t_5);
}
output += "\n        <div class=\"u-global-margin c-social\" data-qa-footer-social-section>";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "socialNavItem")),"childSlugs") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "socialNavItem")),"childSlugs")) > 0) {
output += "<ul class=\"u-clearfix c-social__ul\">";
frame = frame.push();
var t_8 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "socialNavItem")),"childSlugs");
if(t_8) {var t_7 = t_8.length;
for(var t_6=0; t_6 < t_8.length; t_6++) {
var t_9 = t_8[t_6];
frame.set("childSlug", t_9);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
var t_10;
t_10 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),t_9);
frame.set("navItem", t_10, true);
if(frame.topLevel) {
context.setVariable("navItem", t_10);
}
if(frame.topLevel) {
context.addExport("navItem", t_10);
}
if(runtime.contextOrFrameLookup(context, frame, "navItem")) {
output += "\n                        <li class=\"c-social__li c-social__li--";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"slug"), env.opts.autoescape);
output += "\">\n                            ";
output += runtime.suppressValue((lineno = 13, colno = 69, runtime.callWrap(t_4, "renderNavItem", context, [runtime.contextOrFrameLookup(context, frame, "navItem"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_11 = runtime.makeMacro(
["navItem", "url", "target"], 
[], 
function (l_navItem, l_url, l_target, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("navItem", l_navItem);
frame.set("url", l_url);
frame.set("target", l_target);
var t_12 = "";t_12 += "\n\n                                ";
var t_13;
t_13 = runtime.memberLookup((l_navItem),"slug");
frame.set("socialSlug", t_13, true);
if(frame.topLevel) {
context.setVariable("socialSlug", t_13);
}
if(frame.topLevel) {
context.addExport("socialSlug", t_13);
}
t_12 += "\n                                ";
var t_14;
t_14 = "noopener noreferrer";
frame.set("rel", t_14, true);
if(frame.topLevel) {
context.setVariable("rel", t_14);
}
if(frame.topLevel) {
context.addExport("rel", t_14);
}
t_12 += "\n\n                                <a\n                                    ";
t_12 += runtime.suppressValue((lineno = 19, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["footer","social",runtime.contextOrFrameLookup(context, frame, "socialSlug")])), env.opts.autoescape);
t_12 += "\n                                    class=\"c-social__a c-social__a--";
t_12 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "socialSlug"), env.opts.autoescape);
t_12 += "\"\n                                    data-qa-navitem=\"";
t_12 += runtime.suppressValue(runtime.memberLookup((l_navItem),"slug"), env.opts.autoescape);
t_12 += "\"\n                                    ";
if(l_target) {
t_12 += "\n                                    target=\"";
t_12 += runtime.suppressValue(l_target, env.opts.autoescape);
t_12 += "\"\n                                        ";
if(l_target == "_blank") {
t_12 += "\n                                            rel=\"";
t_12 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "rel"), env.opts.autoescape);
t_12 += "\"\n                                        ";
;
}
t_12 += "\n                                    ";
;
}
t_12 += "\n                                    href=\"";
t_12 += runtime.suppressValue(l_url, env.opts.autoescape);
t_12 += "\"\n                                    >";
if(runtime.inOperator(runtime.contextOrFrameLookup(context, frame, "socialSlug"),["social-facebook-de","social-facebook-fr","social-facebook"])) {
env.getTemplate("social/facebook.j2", false, "core/templates/footer/social.j2", null, function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
t_15.render(context.getVariables(), frame, function(t_18,t_16) {
if(t_18) { cb(t_18); return; }
t_12 += t_16
})});
}
if(runtime.contextOrFrameLookup(context, frame, "socialSlug") == "social-instagram") {
env.getTemplate("social/instagram.j2", false, "core/templates/footer/social.j2", null, function(t_21,t_19) {
if(t_21) { cb(t_21); return; }
t_19.render(context.getVariables(), frame, function(t_22,t_20) {
if(t_22) { cb(t_22); return; }
t_12 += t_20
})});
}
if(runtime.inOperator(runtime.contextOrFrameLookup(context, frame, "socialSlug"),["social-twitter-de","social-twitter-fr","social-twitter"])) {
env.getTemplate("social/twitter.j2", false, "core/templates/footer/social.j2", null, function(t_25,t_23) {
if(t_25) { cb(t_25); return; }
t_23.render(context.getVariables(), frame, function(t_26,t_24) {
if(t_26) { cb(t_26); return; }
t_12 += t_24
})});
}
if(runtime.contextOrFrameLookup(context, frame, "socialSlug") == "social-spotify") {
env.getTemplate("social/spotify.j2", false, "core/templates/footer/social.j2", null, function(t_29,t_27) {
if(t_29) { cb(t_29); return; }
t_27.render(context.getVariables(), frame, function(t_30,t_28) {
if(t_30) { cb(t_30); return; }
t_12 += t_28
})});
}
if(runtime.contextOrFrameLookup(context, frame, "socialSlug") == "social-pinterest") {
env.getTemplate("social/pinterest.j2", false, "core/templates/footer/social.j2", null, function(t_33,t_31) {
if(t_33) { cb(t_33); return; }
t_31.render(context.getVariables(), frame, function(t_34,t_32) {
if(t_34) { cb(t_34); return; }
t_12 += t_32
})});
}
if(runtime.contextOrFrameLookup(context, frame, "socialSlug") == "social-youtube") {
env.getTemplate("social/youtube.j2", false, "core/templates/footer/social.j2", null, function(t_37,t_35) {
if(t_37) { cb(t_37); return; }
t_35.render(context.getVariables(), frame, function(t_38,t_36) {
if(t_38) { cb(t_38); return; }
t_12 += t_36
})});
}
if(runtime.contextOrFrameLookup(context, frame, "socialSlug") == "social-googleplus") {
env.getTemplate("social/google-plus.j2", false, "core/templates/footer/social.j2", null, function(t_41,t_39) {
if(t_41) { cb(t_41); return; }
t_39.render(context.getVariables(), frame, function(t_42,t_40) {
if(t_42) { cb(t_42); return; }
t_12 += t_40
})});
}
if(runtime.contextOrFrameLookup(context, frame, "socialSlug") == "social-tumblr") {
env.getTemplate("social/tumblr.j2", false, "core/templates/footer/social.j2", null, function(t_45,t_43) {
if(t_45) { cb(t_45); return; }
t_43.render(context.getVariables(), frame, function(t_46,t_44) {
if(t_46) { cb(t_46); return; }
t_12 += t_44
})});
}
if(runtime.contextOrFrameLookup(context, frame, "socialSlug") == "social-snapchat") {
env.getTemplate("social/snapchat.j2", false, "core/templates/footer/social.j2", null, function(t_49,t_47) {
if(t_49) { cb(t_49); return; }
t_47.render(context.getVariables(), frame, function(t_50,t_48) {
if(t_50) { cb(t_50); return; }
t_12 += t_48
})});
}
if(runtime.contextOrFrameLookup(context, frame, "socialSlug") == "social-songdrop") {
env.getTemplate("social/songdrop.j2", false, "core/templates/footer/social.j2", null, function(t_53,t_51) {
if(t_53) { cb(t_53); return; }
t_51.render(context.getVariables(), frame, function(t_54,t_52) {
if(t_54) { cb(t_54); return; }
t_12 += t_52
})});
}
if(runtime.contextOrFrameLookup(context, frame, "socialSlug") == "social-vimeo") {
env.getTemplate("social/vimeo.j2", false, "core/templates/footer/social.j2", null, function(t_57,t_55) {
if(t_57) { cb(t_57); return; }
t_55.render(context.getVariables(), frame, function(t_58,t_56) {
if(t_58) { cb(t_58); return; }
t_12 += t_56
})});
}
if(runtime.contextOrFrameLookup(context, frame, "socialSlug") == "social-flickr") {
env.getTemplate("social/flickr.j2", false, "core/templates/footer/social.j2", null, function(t_61,t_59) {
if(t_61) { cb(t_61); return; }
t_59.render(context.getVariables(), frame, function(t_62,t_60) {
if(t_62) { cb(t_62); return; }
t_12 += t_60
})});
}
t_12 += "</a>\n\n                            ";
;
frame = frame.pop();
return new runtime.SafeString(t_12);
});
return macro_t_11;})()})])), env.opts.autoescape);
output += "\n                        </li>\n                    ";
;
}
;
}
}
frame = frame.pop();
output += "</ul>";
;
}
output += "</div>";
;
}
;
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/footer/social.j2"] , dependencies)